import Navbar from "./components/Navbar";
import Home from "./components/Home";
import AboutUs from "./components/AboutUs";
//import Gallary from "./components/Gallary";
import Training from "./components/Training";
import ContactUs from "./components/ContactUs";
import MemberRegistration from "./components/MemberRegistration";
import FAQ from "./components/FAQ";
import Events from "./components/Events";
import MemberLogin from "./components/MemberLogin";
import { Routes, Route } from "react-router-dom";
import Carousel from "./components/Carousel";
import Footer from "./components/Footer";
import React from "react";
import MemberRegister from "./components/MemberRegister";
import Account from "./components/Account";
// import EmblaCarousel from "./components/EmblaCarousel";
import Gallery from "./components/Gallery";
import EmblaCarousel from "./components/EmblaCarousel";
import ComradesShoot from "./components/ComradesShoot";
import Comrades2023 from "./components/Comrades2023";
import GalaDinner from "./components/GalaDinner";
import Galla2024 from "./components/Galla2024";
import Galla2023 from "./components/Galla2023";

function App() {
  return (
    <>
      <div className="flex flex-col min-h-screen">
        <main className="flex-0">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/AboutUs" element={<AboutUs />} />
            <Route path="/Gallery" element={<Gallery />} />
            <Route path="/Training" element={<Training />} />
            <Route path="/ContactUs" element={<ContactUs />} />
            <Route
              path="/MemberRegistration"
              element={<MemberRegistration />}
            />
            <Route path="/FAQ" element={<FAQ />} />
            <Route path="/Events" element={<Events />} />
            <Route path="/Carousel" element={<Carousel />} />
            <Route path="/EmblaCarousel" element={<EmblaCarousel />} />
            <Route path="/MemberLogin" element={<MemberLogin />} />
            <Route path="/MemberRegister" element={<MemberRegister />} />
            <Route path="/Account" element={<Account />} />
            <Route path="/ComradesShoot" element={<ComradesShoot />} />
            <Route path="/GalaDinner" element={<GalaDinner />} />
            <Route path="/Comrades2023" element={<Comrades2023 />} />
            <Route path="/Galla2024" element={<Galla2024 />} />
            <Route path="/Galla2023" element={<Galla2023 />} />
          </Routes>
        </main>
        <footer className="text-center">
          <Footer />
        </footer>
      </div>
      {/* <Nav1 /> */}
    </>
  );
}

export default App;
